import { Env } from '../suite/common'

const getEnv = (): Env => {
  switch (window.location.hostname) {
    case 'localhost':
    case 'test.quantcast.com':
      return Env.test
    case 'zoltan.quantcast.com':
    case 'staging.quantcast.com':
      return Env.staging
    case 'quantcast.com':
    default:
      return Env.production
  }
}

const helpCenter = (): string => {
  switch (getEnv()) {
    case Env.test:
      return 'https://help-test.quantcast.com/login'
    case Env.staging:
    case Env.production:
    default:
      return 'https://help.quantcast.com/hc/en-us/categories/360002212334'
  }
}

export default {
  helpCenter
}
